import React from 'react'
import StarRating from './StarRating'

interface RatingSummaryProps {
  averageRating?: number
  totalReviews?: number
}

const RatingSummary: React.FC<RatingSummaryProps> = ({ averageRating, totalReviews }) => {
  if (!totalReviews) {
    return <span className="text-xs text-gray-400">No reviews yet</span>
  }

  return (
    <div className="inline-flex items-center gap-1.5">
      <StarRating value={averageRating || 0} readOnly size="sm" />
      <span className="text-xs text-gray-500">
        {(averageRating || 0).toFixed(1)} ({totalReviews})
      </span>
    </div>
  )
}

export default RatingSummary
